import styled from 'styled-components'
import { css, input } from 'styles'

export const StyledErrorInput = styled.div`
  vertical-align: top;
  ${p => css`
    ${p.inline && 'display: inline-block'};
    ${StyledInput} {
      display: ${p.position === 'vertical' ? '' : 'inline-'}block;
    }
    .errorMsg {
      ${p.position === 'vertical' ? 'width: 100%' : 'margin-left: 2rem'};
      display: inline-block;
      text-align: center;
      color: tomato;
    }
  `}
`

export const StyledPasswordInput = styled.div`
  position: relative;
  a {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    text-decoration: none;
    display: flex;
    padding: 0.8em;
    color: inherit;
  }
`

const StyledInput = styled.input`
  ${input.common};
  transition: 0.3s ease-in;

  &.error {
    border-color: tomato;
  }

  &:focus {
    outline: none;
  }

  &::placeholder {
    font-weight: 600;
  }
`

export default StyledInput
